
export const DEFAULT_PASSWORD_WARNING_MESSAGE = '비밀번호 8자리 이상 입력해주세요.';
export const DEFAULT_ID_WARNING_MESSAGE = '';

export const DEFAULT_NAME_WARNING_MESSAGE = '';

